export default __webpack_public_path__ + "static/media/section-lieder.5c71646b.webp";